class VariantPicker extends HTMLElement {
  constructor() {
    super()

    this.optionSelected = this.optionSelected.bind(this)
    this.addToCart = this.addToCart.bind(this)
    this.optionsSelected = {}
    this.cartDrawer = document.querySelector('cart-drawer')
    this.mobileVariantDialog = document.querySelector('.mod_MobileVariantDialog')
  }

  connectedCallback() {
    this.initialiseData()
    this.initializeElements()
    this.setupEventListeners()
  }

  initialiseData() {
    this.variantDataEl = this.querySelector('[data-variant-picker-el="variant-data"]')
    this.variantData = JSON.parse(this.variantDataEl.textContent)

    this.optionsDataEl = this.querySelector('[data-variant-picker-el="options-data"]')
    this.optionsData = JSON.parse(this.optionsDataEl.textContent)

    this.optionsData.forEach((option, index) => {
      if (option.values.length === 1) {
        this.optionsSelected[index] = option.values[0]
      } else {
        this.optionsSelected[index] = null
      }
    })
  }

  initializeElements() {
    this.optionEls = [...this.querySelectorAll('[data-variant-picker-el="option"]')]
    this.submitEl = this.querySelector('[data-variant-picker-el="submit"]')
  }

  setupEventListeners() {
    this.optionEls.forEach(option => {
      option.addEventListener('click', this.optionSelected)
    })

    if (this.submitEl) {
      this.submitEl.addEventListener('click', this.addToCart)
    }
  }

  findVariants() {
    return this.variantData.filter(variant =>
      Object.entries(this.optionsSelected).every(([index, value]) =>
        variant.options[index] === value
      )
    )
  }

  optionSelected({ target } = {}) {
    const { value = '', optionIndex = null } = target.dataset

    if (!(value && optionIndex)) {
      return
    }

    this.optionsSelected[optionIndex] = value
    this.setSelectedVariant(target)

    const variantsAvailable = this.findVariants()

    if (variantsAvailable.length > 0) {
      this.variantSelected = variantsAvailable[0]
      this.enableSubmit()
    }
  }

  setSelectedVariant(optionEl) {
    this.optionEls.filter(el => el.dataset.optionIndex === optionEl.dataset.optionIndex)
      .forEach(el => {
      el.setAttribute('aria-pressed', false)
    })

    optionEl.setAttribute('aria-pressed', true)
  }

  enableSubmit() {
    if (!this.submitEl) return
    this.submitEl.removeAttribute('disabled')
    this.submitEl.setAttribute('aria-disabled', false)
  }

  async addToCart() {
    const { id } = this.variantSelected

    if (this.submitEl) {
      this.submitEl.setAttribute('aria-busy', true)
    }

    if (!id) {
      console.error('NO VARIANT AVAILABLE')
      return
    }

    const sections = this.cartDrawer.getSectionsToRender().map((section) => section.id)

    const body = JSON.stringify({
      sections,
      items: [
        {
          quantity: 1,
          id,
        },
      ],
    })

    try {
      const response = await fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
      const state = await response.text()
      const parsedState = JSON.parse(state)

      if (this.dataset.target === 'cart-upsell') {
        await this.updateCartAttribute('_upsell-dismissed', true)
      }

      publish(PUB_SUB_EVENTS.cartUpdate, {
        source: this.dataset.target,
        cartData: parsedState,
        variantId: id,
      })

      if (this.cartDrawer && !this.cartDrawer.isActive()) {
        this.cartDrawer.renderContents(parsedState)
      }

      if (this.mobileVariantDialog) {
        this.mobileVariantDialog.close()
      }
    } catch (error) {
      console.error('Error adding to cart:', error)

    } finally {
      if (this.submitEl) {
        this.submitEl.removeAttribute('aria-busy')
      }
    }
  }


  async updateCartAttribute(key, value) {
    try {
      const response = await fetch(`${routes.cart_update_url}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          attributes: { [key]: value },
        }),
      })

      if (!response.ok) {
        throw new Error('Network response not OK')
      }

    } catch (error) {
      console.error('Failed to POST cart attribute', error)
    }
  }
}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker)
}

